import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-home-jumbotron",
  templateUrl: "./home-jumbotron.html",
  styleUrls: ["./home-jumbotron.scss"],
})
export class HomeJumbotronComponent implements OnInit {
  heroImages: string[] = [
    "https://company.rubbl.com/pubweb/marketplace/homepage/hero_1.jpg",
    "https://company.rubbl.com/pubweb/marketplace/homepage/hero_2.jpg",
    "https://company.rubbl.com/pubweb/marketplace/homepage/hero_3.jpg",
    "https://company.rubbl.com/pubweb/marketplace/homepage/hero_4.jpg",
    "https://company.rubbl.com/pubweb/marketplace/homepage/hero_5.jpg",
  ];

  currentHeroImage: string = "";

  constructor() {}

  ngOnInit() {
    this.currentHeroImage = this.heroImages[Math.floor(Math.random() * this.heroImages.length)];
  }
}
